import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';

import {
  FilterBadge,
  MobileSearchFilterButtonHolder,
} from './MobileSearchFilterButton.styled';

type Props = {
  onClick: () => void;
  activeFilterCount: number;
};

export function MobileSearchFilterButton({
  onClick,
  activeFilterCount,
}: Props) {
  const { i18n } = useI18n();

  return (
    <MobileSearchFilterButtonHolder>
      <Button
        type="button"
        variant="tertiary-grey"
        icon={{ name: 'filters' }}
        aria-label={i18n('Open search filters')}
        qaId="mobile-search-filter-button"
        onClick={onClick}
      />
      {activeFilterCount > 0 && (
        <FilterBadge data-qa-id="filter-count-badge">
          {activeFilterCount}
        </FilterBadge>
      )}
    </MobileSearchFilterButtonHolder>
  );
}
